var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('route-header',[_c('h3',[_vm._v(_vm._s(_vm.$tc('labels.project', 0)))])]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('projects')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }